import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ResponsiveService } from '@service/responsive.service';

@Component({
    selector: 'app-filterbar',
    templateUrl: './filterbar.component.html',
    styleUrls: ['./filterbar.component.scss'],
    standalone: false
})
export class FilterbarComponent implements OnDestroy {
    @Input() filterOption: any;
    @Input() filterbarLabels: FilterLabel[];
    @Input() showSimpleFilter: Set<string>;
    @Input() simpleFilterLabel: any;
    @Output() onFilterChange = new EventEmitter();
    @Output() resetFilter = new EventEmitter();
    public showSearchDivider: boolean = true;

    constructor(public responsive: ResponsiveService) {}

    ngOnDestroy(): void {
        this.onResetFilterEmit();
    }

    isShowSimpleFilter() {
        return this.showSimpleFilter.has(this.responsive.screenSize);
    }

    onChangeEmit(model, event) {
        this.onFilterChange.emit({ [model]: event });
    }

    onResetFilterEmit() {
        this.resetFilter.emit();
    }
}

export enum AlarmLevels {
    LOW = 'LOW',
    LOWLOW = 'LOW-LOW',
    HIGHHIGH = 'HIGH-HIGH',
    HIGH = 'HIGH',
    FAIL = 'FAIL',
    ABNORMAL = 'ABNORMAL',
    UNDEFINED = '',
}

export interface FilterAlarmOptions {
    status: AlarmLevels;
    channel: string;
}

export interface FilterChannelOptions {
    channelNo: string;
    channel: string;
}

export enum CalendarOptions {
    OCCURRENCE = 'occurrence',
    RECOVERY = 'recovery',
}

export interface FilterLabel {
    header: string;
    placeholder: string;
    model: string;
}
